import WorkshopB2BDataService from "../../services/WorkshopB2B";
import { SingleWorkshopB2BRow } from "../../components/List/SingleWorkshopB2BRow";
import { Select, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { default as ReactSelect } from "react-select";
import { useNavigate } from "react-router-dom";
import { useDisclosure } from "@chakra-ui/react";
import { FilterMonthYearModal } from "../../components/Modals/FilterMonthYearModal";
import { FilterB2BWorkshopModal } from "../../components/Modals/FilterB2BWorkshopModal";
import { MonthlyB2BExpertDownloadBillingSheet } from "../../components/Modals/MonthlyB2BExpertDownloadBillingSheet";
import { State } from "country-state-city";

export const WorkshopB2BList = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("logged_in_user_token");
  const { onOpen, isOpen, onClose } = useDisclosure();
  const [list, setList] = useState<any>([]);
  const [filterList, setFilterList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const toast = useToast();
  const [drawer, setDrawer] = useState("");

  const [state, setState] = useState("");

  const states = State.getStatesOfCountry("IN").map((state) => {
    return { label: state.name, value: state.name };
  });
  const stateOptions = [{ label: "Online", value: "Online" }, ...states];

  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [expert, setExpert] = useState("");
  const [status, setStatus] = useState("");

  const getFilteredMonthYearExpert = (
    month: string,
    year: string,
    expert: string,
    status: string
  ) => {
    setMonth(month);
    setYear(year);
    setExpert(expert);
    setStatus(status);
  };

  const isNgodelete = (isdelete: true) => {
    fetchData();
  };

  const fetchData = async () => {
    WorkshopB2BDataService.getAllB2BWorkshops(
      token,
      month,
      year,
      expert,
      status
    )
      .then((res: any) => {
        setList(res.data.data);
        setFilterList(res.data.data);
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  const handleSubmit = async (state: any) => {
    WorkshopB2BDataService.getFilteredB2BWorkshopByLocation(state)
      .then((res: any) => {
        setFilterList(res.data.data);
        setIsLoading(false);
      })
      .catch((error: any) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, [month, year, expert, status]);

  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Workshops - B2B Workshop</div>
        <div className="p-4">
          <div className="flex">
            <div>
              <div className="mb-3">
                <button
                  type="button"
                  className="btn action-btn custom-btn"
                  onClick={() => navigate("add")}
                >
                  Create Workshop
                </button>
              </div>
              <div className="mb-3">
                <button
                  type="button"
                  className="btn action-btn custom-btn"
                  onClick={() => {
                    setDrawer("expertlist");
                    onOpen();
                  }}
                >
                  Monthly Expert Billing
                </button>
                {drawer === "expertlist" && (
                  <FilterMonthYearModal isOpen={isOpen} onClose={onClose} />
                )}
              </div>
            </div>
            <div>
              <div className="mb-3">
                <button
                  type="button"
                  className="btn action-btn custom-btn"
                  onClick={() => {
                    setDrawer("filterlist");
                    onOpen();
                  }}
                >
                  Filter Monthly Workshop
                </button>
                {drawer === "filterlist" && (
                  <FilterB2BWorkshopModal
                    isOpen={isOpen}
                    onClose={onClose}
                    func={getFilteredMonthYearExpert}
                  />
                )}
              </div>
              <div className="mb-3">
                <button
                  type="button"
                  className="btn action-btn custom-btn"
                  onClick={() => {
                    setDrawer("monthlysheet");
                    onOpen();
                  }}
                >
                  Download Monthly Sheet
                </button>

                {drawer === "monthlysheet" && (
                  <MonthlyB2BExpertDownloadBillingSheet
                    isOpen={isOpen}
                    onClose={onClose}
                  />
                )}
              </div>
            </div>
            <div
              className="self-start"
              style={{
                alignSelf: "flex-start",
                height: "auto",
                minHeight: "unset",
              }}
            >
              <ReactSelect
                id="state"
                name="state"
                options={stateOptions}
                placeholder="Choose State"
                isClearable
                value={stateOptions.find(
                  (option: any) => option.value === state
                )}
                onChange={(option) => {
                  setState(option ? option.value : "");
                  option &&
                    option.value &&
                    handleSubmit(option ? option.value : "");
                }}
                classNamePrefix="react-select"
                styles={{
                  control: (base) => ({
                    ...base,
                    fontSize: "15px",
                    borderColor: "#327171",
                    width: "250px",
                    textAlign: "left",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    fontSize: "15px",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    fontSize: "15px",
                  }),
                  menu: (base) => ({
                    ...base,
                    fontSize: "15px",
                  }),
                  option: (base) => ({
                    ...base,
                    textAlign: "left",
                    fontSize: "15px",
                  }),
                }}
              />
              {/* <Select
                  id="state"
                  
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  placeholder="Select State"
                >
                  {stateOptions.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </Select> */}
            </div>
          </div>
          <div className="main-section" style={{ overflowX: "auto" }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Edit</th>
                  <th>View</th>
                  <th>Title</th>
                  <th>Date</th>
                  {/* <th>Start Time</th> */}
                  {/* <th>End Time</th> */}
                  <th>Status</th>
                  <th>Location</th>
                  {/* <th>State</th> */}
                  <th>Client</th>
                  <th>Expert Name</th>
                  <th>Expert Price</th>
                  <th>TDS</th>
                  <th>Payment After TDS</th>
                  <th>Payment Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filterList && filterList.length > 0 ? (
                  filterList.map((el: any) => (
                    <SingleWorkshopB2BRow
                      key={el.id}
                      props={el}
                      id={el._id}
                      func={isNgodelete}
                    />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
